<ng-container *hasPermission="PermissionForStudents.PLACEMENT_VIEW">
<div class="page-container">
    <div class="hero-section">
        <div class="hero-content">
            <h2>Mock <span class="highlight">Test</span></h2>
            <p>Master your aptitude and technical skills with our AI-powered mock interface.</p>
        </div>

        <button class="start-btn" [routerLink]="['/student-dashboard/placement-test-type']">
            <mat-icon>rocket_launch</mat-icon>
            <span class="btn-text">Practice Mock Test</span>
        </button>
    </div>

    <div class="tabs-container">
        <div class="tabs-list">
            <button class="tab-btn" [class.active]="activeTab === 'mock-test'" (click)="selectTab('mock-test')">
                All Mock Tests
            </button>
            <button class="tab-btn" [class.active]="activeTab === 'history'" (click)="selectTab('history')">
                Test History
            </button>
        </div>
    </div>

    <div class="placement-tab-content" *ngIf="activeTab === 'mock-test'">

        <div class="history-header">
            <div class="history-header-left">
                <h2>All Mock Tests</h2>
                <p>Explore AI practice and company specific mock tests</p>
            </div>

            <div class="history-header-right">
                <button mat-stroked-button [matMenuTriggerFor]="qsSourceFilterMenu" class="filter-dropdown-btn"
                    [class.has-filter]="quickStartSourceFilter !== 'all'">
                    <mat-icon>filter_list</mat-icon>
                    <span>{{ getQuickStartSourceFilterLabel() }}</span>
                    <mat-icon class="filter-arrow">arrow_drop_down</mat-icon>
                </button>
                <mat-menu #qsSourceFilterMenu="matMenu">
                    <button mat-menu-item *ngFor="let opt of historyFilterOptions" (click)="setQuickStartSourceFilter(opt.value)">
                        <span [class.fw-bold]="quickStartSourceFilter === opt.value">{{ opt.label }}</span>
                        <mat-icon *ngIf="quickStartSourceFilter === opt.value" class="menu-check">check</mat-icon>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div class="controls-bar">
            <div class="search-box">
                <mat-icon>search</mat-icon>
                <input type="text" placeholder="Search tests..." [(ngModel)]="quickStartSearchQuery"
                    (ngModelChange)="applyQuickStartFilters()">
                <button type="button" class="clear-search-btn" *ngIf="quickStartSearchQuery" (click)="clearQuickStartSearch()" aria-label="Clear search">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <!-- Company Specific Mock Test Filters: Role Name & Test Category -->
            <div class="filters company-specific-filters" *ngIf="quickStartSourceFilter === 'company-specific'">
                <div class="role-dropdown-container">
                    <button type="button" class="filter-dropdown-btn role-trigger-btn"
                        [class.has-filter]="!!selectedRoleName"
                        (click)="toggleRoleDropdown($event)"
                        aria-label="Filter by Role Name">
                        <mat-icon class="filter-icon">work_outline</mat-icon>
                        <span class="dropdown-selected-text">
                            {{ selectedRoleName ? selectedRoleName : 'Select/Search Role' }}
                        </span>
                        <button type="button" class="clear-chip-btn" *ngIf="selectedRoleName"
                            (click)="clearSelectedRole($event)" aria-label="Clear role filter" title="Clear role">
                            <mat-icon>close</mat-icon>
                        </button>
                        <mat-icon class="filter-arrow">arrow_drop_down</mat-icon>
                    </button>

                    <div class="role-dropdown-menu" *ngIf="isRoleDropdownOpen" (click)="$event.stopPropagation()">
                        <div class="dropdown-search-input">
                            <mat-icon>search</mat-icon>
                            <input type="text" placeholder="Search roles..." [(ngModel)]="roleSearchQuery" autofocus>
                            <button type="button" class="clear-search-btn" *ngIf="roleSearchQuery"
                                (click)="roleSearchQuery = ''" aria-label="Clear search">
                                <mat-icon>close</mat-icon>
                            </button>
                        </div>
                        <div class="role-dropdown-list">
                            <div class="role-option-item" [class.selected]="!selectedRoleName"
                                (click)="onSelectRole('')">
                                <span>All Roles</span>
                                <mat-icon *ngIf="!selectedRoleName" class="menu-check">check</mat-icon>
                            </div>
                            <div class="role-option-item custom-match"
                                *ngIf="roleSearchQuery && !filteredRoles.includes(roleSearchQuery)"
                                (click)="onSelectRole(roleSearchQuery)">
                                <span>Use "{{ roleSearchQuery }}"</span>
                                <mat-icon class="menu-check">add</mat-icon>
                            </div>
                            <div class="role-option-item" *ngFor="let role of filteredRoles"
                                [class.selected]="selectedRoleName === role"
                                (click)="onSelectRole(role)">
                                <span>{{ role }}</span>
                                <mat-icon *ngIf="selectedRoleName === role" class="menu-check">check</mat-icon>
                            </div>
                            <div class="role-empty-message" *ngIf="filteredRoles.length === 0 && !roleSearchQuery">
                                No roles found
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 2. Test Category Dropdown -->
                <div class="category-dropdown-container">
                    <button mat-stroked-button [matMenuTriggerFor]="qsTestCategoryMenu" class="filter-dropdown-btn"
                        [class.has-filter]="selectedTestCategory !== 'All'">
                        <mat-icon class="filter-icon">category</mat-icon>
                        <span>Test Category: {{ selectedTestCategory }}</span>
                        <mat-icon class="filter-arrow">arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #qsTestCategoryMenu="matMenu">
                        <button mat-menu-item *ngFor="let cat of testCategoryOptions" (click)="onSelectCategory(cat)">
                            <span [class.fw-bold]="selectedTestCategory === cat">{{ cat }}</span>
                            <mat-icon *ngIf="selectedTestCategory === cat" class="menu-check">check</mat-icon>
                        </button>
                    </mat-menu>
                </div>
            </div>

            <!-- Existing Filters for AI Practice / All -->
            <div class="filters" *ngIf="quickStartSourceFilter !== 'company-specific'">
                <button mat-stroked-button [matMenuTriggerFor]="qsFilterMenu" class="filter-dropdown-btn"
                    *ngIf="!quickStartSelectedFilter">
                    <mat-icon>filter_list</mat-icon> All Filters
                </button>

                <button mat-stroked-button class="filter-dropdown-btn has-filter" *ngIf="quickStartSelectedFilter"
                    (click)="setQuickStartFilter(null)">
                    <mat-icon>close</mat-icon> {{ getFilterLabel(quickStartSelectedFilter) }}
                </button>
                <mat-menu #qsFilterMenu="matMenu">
                    <button mat-menu-item (click)="setQuickStartFilter(null)">All</button>
                    <button mat-menu-item *ngFor="let option of filterOptions"
                        (click)="setQuickStartFilter(option.value)">
                        <span [class.fw-bold]="quickStartSelectedFilter === option.value">{{ option.label }}</span>
                        <mat-icon *ngIf="quickStartSelectedFilter === option.value" class="menu-check">check</mat-icon>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div class="cards-grid" *ngIf="filteredQuickStartTests.length > 0">
            <div class="mock-card" *ngFor="let test of filteredQuickStartTests">
                <div class="card-header">
                    <div class="card-header-left">
                        <div class="company-logo-container" *ngIf="test.test_config?.company_logo">
                            <img [src]="test.test_config.company_logo"
                                [alt]="(test.test_config.company_name || 'Company') + ' logo'"
                                class="company-standalone-logo"
                                (error)="onCompanyLogoError(test)" />
                        </div>
                    <div class="category-badge"
                        [ngClass]="(test.test_config.company_name || test.test_config.company_logo) ? 'badge-indigo' : getTestTypeClass(test.test_type)">
                        <mat-icon *ngIf="!test.test_config?.company_logo">{{ test.test_config.company_name ? 'business' : getTestTypeIcon(test.test_type) }}</mat-icon>
                        <ng-container *ngIf="test.test_name">
                            <span *ngIf="test.test_config.company_name">{{ test.test_config.company_name }}</span>
                            <span *ngIf="!test.test_config.company_name">{{ getTestTypeLabel(test.test_type) }}</span>
                        </ng-container>
                        <ng-container *ngIf="!test.test_name">
                            <span>{{ getTestTypeLabel(test.test_type) }}</span>
                        </ng-container>
                        </div>
                    </div>
                    <span class="difficulty-badge" *ngIf="test.test_config.difficulty"
                        [class.easy]="test.test_config.difficulty === 'Easy'"
                        [class.medium]="test.test_config.difficulty === 'Medium'"
                        [class.hard]="test.test_config.difficulty === 'Hard'">
                        {{ test.test_config.difficulty }}
                    </span>
                </div>

                <h3 class="test-title" [title]="test.displayTitle">{{ test.displayTitle }}</h3>

                <div class="company-row" *ngIf="test.test_config.role" [title]="test.test_config.role">
                    <mat-icon>work</mat-icon>
                    <span>{{ test.test_config.role }}</span>
                </div>

                <div class="topics-list" *ngIf="test.cleanTopics && test.cleanTopics.length > 0">
                    <span class="topic-tag" *ngFor="let topic of test.cleanTopics | slice:0:3">{{ topic }}</span>
                    <span class="topic-tag more" *ngIf="test.cleanTopics.length > 3">+{{ test.cleanTopics.length - 3
                        }}</span>
                </div>

                <div class="test-details" *ngIf="test.total_questions != null && test.total_questions > 0">
                    <div class="detail-item">
                        <mat-icon>description</mat-icon>
                        <span>{{ test.total_questions }} Qs</span>
                    </div>

                </div>

                <div class="card-actions">
                    <ng-container *ngIf="test.latest_attempt_status === 'IN_PROGRESS'; else passedCheck">

						<button mat-stroked-button class="start-test-btn resume" (click)="resumeTest(test)"
						*hasPermission="PermissionForStudents.PLACEMENT_TAKE">
                            <mat-icon>play_circle_outline</mat-icon>
                            <span>Resume Test</span>
                        </button>

                    </ng-container>

                    <ng-template #passedCheck>
                        <ng-container
                            *ngIf="isSubmittedStatus(test.latest_attempt_status) && test.user_attempts_count >= 1; else startBtn">
                            <button mat-stroked-button class="start-test-btn" (click)="retakeTest(test)"
								*hasPermission="PermissionForStudents.PLACEMENT_TAKE"
                                [disabled]="activeStartingTestId && activeStartingTestId !== test.test_id">
                                <mat-icon *ngIf="activeStartingTestId === test.test_id">hourglass_empty</mat-icon>
                                <mat-icon *ngIf="activeStartingTestId !== test.test_id">refresh</mat-icon>
                                <span *ngIf="activeStartingTestId !== test.test_id">Retake Test</span>
                                <span *ngIf="activeStartingTestId === test.test_id">Starting...</span>
                            </button>
                        </ng-container>
                    </ng-template>

                    <ng-template #startBtn>

                        <button mat-stroked-button class="start-test-btn" (click)="startTest(test)"
                            [disabled]="activeStartingTestId && activeStartingTestId !== test.test_id"
							*hasPermission="PermissionForStudents.PLACEMENT_TAKE">

                            <mat-icon *ngIf="activeStartingTestId === test.test_id">hourglass_empty</mat-icon>

                            <span *ngIf="activeStartingTestId !== test.test_id">Start Mock Test</span>
                            <span *ngIf="activeStartingTestId === test.test_id">Starting...</span>

                        </button>

                    </ng-template>
                </div>
            </div>
        </div>

        <div class="empty-state" *ngIf="filteredQuickStartTests.length === 0 && !isLoading">
            <mat-icon>search_off</mat-icon>
            <p *ngIf="quickStartSearchQuery && quickStartSelectedFilter">No tests found matching '{{ quickStartSearchQuery }}' in {{ getFilterLabel(quickStartSelectedFilter) }}</p>
            <p *ngIf="quickStartSearchQuery && !quickStartSelectedFilter">No tests found matching '{{ quickStartSearchQuery }}'</p>
            <p *ngIf="!quickStartSearchQuery && quickStartSelectedFilter">We don't have {{ getFilterLabel(quickStartSelectedFilter) }} tests for the selected filter</p>
            <p *ngIf="!quickStartSearchQuery && !quickStartSelectedFilter && quickStartSourceFilter === 'ai-practice'">No AI Practice Mock Tests available.</p>
            <p *ngIf="!quickStartSearchQuery && !quickStartSelectedFilter && quickStartSourceFilter === 'company-specific' && (selectedRoleName || selectedTestCategory !== 'All')">
                No Company Specific Mock Tests found for {{ selectedRoleName ? selectedRoleName : '' }}{{ selectedRoleName && selectedTestCategory !== 'All' ? ' (' + selectedTestCategory + ')' : (selectedTestCategory !== 'All' ? selectedTestCategory : '') }}.
            </p>
            <p *ngIf="!quickStartSearchQuery && !quickStartSelectedFilter && quickStartSourceFilter === 'company-specific' && !selectedRoleName && selectedTestCategory === 'All'">No Company Specific Mock Tests available.</p>
            <p *ngIf="!quickStartSearchQuery && !quickStartSelectedFilter && quickStartSourceFilter === 'all'">No mock tests available.</p>
        </div>

        <div class="loading-state" *ngIf="isLoading && quickStartTests.length === 0">
            <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div class="load-more-container" *ngIf="filteredQuickStartTests.length >= quickStartPageSize && hasMoreQuickStart">
            <button mat-stroked-button class="load-more-btn" (click)="loadMoreQuickStart()"
                [disabled]="isLoadingMoreQuickStart">
                <span *ngIf="!isLoadingMoreQuickStart">Load More Tests</span>
                <span *ngIf="isLoadingMoreQuickStart">Loading...</span>
            </button>
        </div>
    </div>

    <div class="placement-tab-content history-content" *ngIf="activeTab === 'history'">

        <div class="history-container">
            <div class="history-header">
                <div class="history-header-left">
                    <h2>Test History</h2>
                    <p>View all your completed mock tests</p>
                </div>

                <div class="history-header-right">
                    <button mat-stroked-button [matMenuTriggerFor]="historyFilterMenu" class="filter-dropdown-btn"
                        [class.has-filter]="historyFilter !== 'all'">
                        <mat-icon>filter_list</mat-icon>
                        <span>{{ getHistoryFilterLabel() }}</span>
                        <mat-icon class="filter-arrow">arrow_drop_down</mat-icon>
                    </button>
                    <mat-menu #historyFilterMenu="matMenu">
                        <button mat-menu-item *ngFor="let opt of historyFilterOptions" (click)="setHistoryFilter(opt.value)">
                            <span [class.fw-bold]="historyFilter === opt.value">{{ opt.label }}</span>
                            <mat-icon *ngIf="historyFilter === opt.value" class="menu-check">check</mat-icon>
                        </button>
                    </mat-menu>
                </div>
            </div>

            <div class="controls-bar">
                <div class="search-box">
                    <mat-icon>search</mat-icon>
                    <input type="text" placeholder="Search tests..." [(ngModel)]="searchQuery"
                        (ngModelChange)="applyFilters()">
                    <button type="button" class="clear-search-btn" *ngIf="searchQuery" (click)="clearSearch()" aria-label="Clear search">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>

                <!-- Company Specific Mock Test Filters: Role Name & Test Category -->
                <div class="filters company-specific-filters" *ngIf="historyFilter === 'company-specific'">
                    <div class="role-dropdown-container">
                        <button type="button" class="filter-dropdown-btn role-trigger-btn"
                            [class.has-filter]="!!selectedRoleName"
                            (click)="toggleRoleDropdown($event)"
                            aria-label="Filter by Role Name">
                            <mat-icon class="filter-icon">work_outline</mat-icon>
                            <span class="dropdown-selected-text">
                                {{ selectedRoleName ? selectedRoleName : 'Select/Search Role' }}
                            </span>
                            <button type="button" class="clear-chip-btn" *ngIf="selectedRoleName"
                                (click)="clearSelectedRole($event)" aria-label="Clear role filter" title="Clear role">
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-icon class="filter-arrow">arrow_drop_down</mat-icon>
                        </button>

                        <div class="role-dropdown-menu" *ngIf="isRoleDropdownOpen" (click)="$event.stopPropagation()">
                            <div class="dropdown-search-input">
                                <mat-icon>search</mat-icon>
                                <input type="text" placeholder="Search roles..." [(ngModel)]="roleSearchQuery" autofocus>
                                <button type="button" class="clear-search-btn" *ngIf="roleSearchQuery"
                                    (click)="roleSearchQuery = ''" aria-label="Clear search">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </div>
                            <div class="role-dropdown-list">
                                <div class="role-option-item" [class.selected]="!selectedRoleName"
                                    (click)="onSelectRole('')">
                                    <span>All Roles</span>
                                    <mat-icon *ngIf="!selectedRoleName" class="menu-check">check</mat-icon>
                                </div>
                                <div class="role-option-item" *ngFor="let role of filteredRoles"
                                    [class.selected]="selectedRoleName === role"
                                    (click)="onSelectRole(role)">
                                    <span>{{ role }}</span>
                                    <mat-icon *ngIf="selectedRoleName === role" class="menu-check">check</mat-icon>
                                </div>
                                <div class="role-empty-message" *ngIf="filteredRoles.length === 0">
                                    No roles found
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 2. Test Category Dropdown -->
                    <div class="category-dropdown-container">
                        <button mat-stroked-button [matMenuTriggerFor]="testCategoryMenu" class="filter-dropdown-btn"
                            [class.has-filter]="selectedTestCategory !== 'All'">
                            <mat-icon class="filter-icon">category</mat-icon>
                            <span>Test Category: {{ selectedTestCategory }}</span>
                            <mat-icon class="filter-arrow">arrow_drop_down</mat-icon>
                        </button>
                        <mat-menu #testCategoryMenu="matMenu">
                            <button mat-menu-item *ngFor="let cat of testCategoryOptions" (click)="onSelectCategory(cat)">
                                <span [class.fw-bold]="selectedTestCategory === cat">{{ cat }}</span>
                                <mat-icon *ngIf="selectedTestCategory === cat" class="menu-check">check</mat-icon>
                            </button>
                        </mat-menu>
                    </div>
                </div>

                <!-- Existing All Filters dropdown for AI practice / All -->
                <div class="filters" *ngIf="historyFilter !== 'company-specific'">
                    <button mat-stroked-button [matMenuTriggerFor]="historyCategoryFilterMenu" class="filter-dropdown-btn"
                        *ngIf="!selectedFilter">
                        <mat-icon>filter_list</mat-icon> All Filters
                    </button>

                    <button mat-stroked-button class="filter-dropdown-btn has-filter" *ngIf="selectedFilter"
                        (click)="setFilter(null)">
                        <mat-icon>close</mat-icon> {{ getFilterLabel(selectedFilter) }}
                    </button>
                    <mat-menu #historyCategoryFilterMenu="matMenu">
                        <button mat-menu-item (click)="setFilter(null)">All</button>
                        <button mat-menu-item *ngFor="let option of filterOptions" (click)="setFilter(option.value)">
                            <span [class.fw-bold]="selectedFilter === option.value">{{ option.label }}</span>
                            <mat-icon *ngIf="selectedFilter === option.value" class="menu-check">check</mat-icon>
                        </button>
                    </mat-menu>
                </div>
            </div>

            <div class="attempts-list">
                <div class="attempt-card" *ngFor="let attempt of filteredAttempts">
                    <div class="card-left">
                        <div class="title-row">
                            <h3 class="attempt-title">{{ attempt.test_name || formatTestType(attempt.test_type) }}</h3>
                            <span class="attempt-badge" *ngIf="attempt.total_attempts">
                                <mat-icon class="small-icon">history</mat-icon> Attempt {{ attempt.total_attempts }}
                            </span>
                        </div>

                        <div class="badge-row">
                            <span class="type-badge">{{ getTestTypeLabel(attempt.test_type) }}</span>
                            <span class="meta-item"><mat-icon class="small-icon">calendar_today</mat-icon> {{
                                attempt.created_at | date:'dd/MM/yyyy' }}</span>
                            <span class="meta-item"><mat-icon class="small-icon">schedule</mat-icon> {{
                                getDisplayTime(attempt) }}</span>
                            <span class="difficulty-pill" *ngIf="attempt.difficulty"
                                [ngClass]="attempt.difficulty.toLowerCase()">{{ attempt.difficulty }}</span>
                        </div>
                    </div>

                    <div class="card-right">
                        <div class="score-display" *ngIf="attempt.status !== 'IN_PROGRESS'">
                            <div class="score-percentage">
                                <mat-icon *ngIf="(attempt.score_percentage || 0) >= 50"
                                    class="pass-icon">emoji_events</mat-icon>
                                <span [class.pass]="(attempt.score_percentage || 0) >= 50"
                                    [class.fail]="(attempt.score_percentage || 0) < 50">
                                    {{ attempt.score_percentage || 0 }}%
                                </span>
                            </div>
                            <span class="score-fraction">{{ attempt.obtained_marks || 0 }}/{{ attempt.total_marks || 0 }}</span>
                        </div>

                        <div class="actions">

							<ng-container *hasPermission="PermissionForStudents.PLACEMENT_VIEW_RESULTS">
                            <button mat-stroked-button class="view-btn" (click)="viewResult(attempt)"
                                *ngIf="attempt.status !== 'IN_PROGRESS'">
                                <mat-icon>visibility</mat-icon> View
                            </button>
							</ng-container>

							<ng-container *hasPermission="PermissionForStudents.PLACEMENT_TAKE">
                            <button mat-flat-button color="primary" class="resume-btn" (click)="resumeTest(attempt)"
                                *ngIf="attempt.status === 'IN_PROGRESS'">
                                <mat-icon>play_arrow</mat-icon> Resume
                            </button>

                            <button mat-flat-button class="retake-btn" (click)="retakeTest(attempt)"
                                *ngIf="attempt.status !== 'IN_PROGRESS' && attempt.retake_permitted">
                                <mat-icon>refresh</mat-icon> Retake
                            </button>
							</ng-container>

                        </div>
                    </div>
                </div>

                <div class="empty-state" *ngIf="filteredAttempts.length === 0 && !isLoading">
                    <mat-icon>history_toggle_off</mat-icon>
                    <p *ngIf="searchQuery && selectedFilter">No tests found matching '{{ searchQuery }}' in {{ getFilterLabel(selectedFilter) }}</p>
                    <p *ngIf="searchQuery && !selectedFilter">No tests found matching '{{ searchQuery }}'</p>
                    <p *ngIf="!searchQuery && selectedFilter">You don't have {{ getFilterLabel(selectedFilter) }} tests in Test History</p>
                    <p *ngIf="!searchQuery && !selectedFilter && historyFilter === 'ai-practice'">No AI Practice Mock Test history found.</p>
                    <p *ngIf="!searchQuery && !selectedFilter && historyFilter === 'company-specific' && (selectedRoleName || selectedTestCategory !== 'All')">
                        No Company Specific Mock Tests found for {{ selectedRoleName ? selectedRoleName : '' }}{{ selectedRoleName && selectedTestCategory !== 'All' ? ' (' + selectedTestCategory + ')' : (selectedTestCategory !== 'All' ? selectedTestCategory : '') }}.
                    </p>
                    <p *ngIf="!searchQuery && !selectedFilter && historyFilter === 'company-specific' && !selectedRoleName && selectedTestCategory === 'All'">No Company Specific Mock Test history found.</p>
                    <p *ngIf="!searchQuery && !selectedFilter && historyFilter === 'all'">No test history found.</p>
                </div>

                <div class="loading-state" *ngIf="isLoading && attempts.length === 0">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>
            </div>

            <div class="load-more-container" *ngIf="filteredAttempts.length >= historyPageSize && hasMoreHistory">
                <button mat-stroked-button class="load-more-btn" (click)="loadMoreHistory()"
                    [disabled]="isLoadingMoreHistory">
                    <span *ngIf="!isLoadingMoreHistory">Load More</span>
                    <span *ngIf="isLoadingMoreHistory">Loading...</span>
                </button>
            </div>
        </div>
    </div>
</div>
</ng-container>
